import moment from 'moment-jalaali';

const config = {
    productPath: '/files/product/image/',
    blogPath: '/files/blog/index/',
    authorPath: '/files/blog/author/',
    bannerPath: '/files/blog/image/',
    videoPath: '/files/blog/video/',
    podcastPath: '/files/blog/podcast/'
};
export default config;

const formaturl = (title) => {
    return title
      .trim()
      .toLowerCase() // تبدیل حروف به حروف کوچک
      .replace(/[:؟()!?]/g, '') // حذف کاراکترهای خاص
      .replace(/[ '\\"*/,_&#^@.×x،-]/g, '-') // جایگزینی کاراکترهای خاص با خط تیره
      .replace(/-+/g, '-') // جایگزینی چند خط تیره پشت سر هم با یک خط تیره
      .replace(/^-|-$/g, ''); // حذف خط تیره‌های ابتدا و انتهای رشته
  };
  export { formaturl };
  

const unformatUrl = (formattedTitle) => {
    if (!formattedTitle) {
        return '';
    }
    return formattedTitle.replace(/-/g, ' '); 
}
export { unformatUrl };

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const jalaliDate = moment(date).format('jYYYY/jM/jD');
    const gregorianDate = moment(date).format('YYYY-MM-DD');
    return { jalaliDate, gregorianDate };
};
export { formatDate };


const formatJalaliToGregorian = (jalaliDateString) => {
    const gregorianDate = moment(jalaliDateString, 'jYYYY/jM/jD').format('YYYY/MM/DD');
    return gregorianDate;
};

export { formatJalaliToGregorian };


